import { NgIf } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Button } from "@ankaadia/ankaadia-shared-frontend";
import { CheckboxModule } from "primeng-v17/checkbox";
import { FormElementMapModule } from "../../../../shared/from-element-map/form-element-map.module";
import { TestIdDirective } from "../../../../shared/test-id/test-id.directive";
import { TranslateDirective } from "../../../../shared/transloco/translate.directive";
import { TcConsentViewComponent } from "../tc-consent-view/tc-consent-view.component";
import { NewUiTcConsentDialogComponent } from "./new-ui-tc-consent-dialog.component";

@Component({
  selector: "app-tc-consent-dialog",
  templateUrl: "./tc-consent-dialog.component.html",
  styleUrl: "./tc-consent-dialog.component.scss",
  imports: [
    NgIf,
    TranslateDirective,
    TcConsentViewComponent,
    CheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    FormElementMapModule,
    TestIdDirective,
    Button,
  ],
})
export class TcConsentDialogComponent extends NewUiTcConsentDialogComponent {}
